"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartError = void 0;
const pushToDataLayer_1 = require("../pushToDataLayer");
function trackCartError(eventLabel) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: 'Cart',
        eventAction: 'Error',
        eventLabel,
    });
}
exports.trackCartError = trackCartError;
//# sourceMappingURL=trackCartError.js.map